<template>
    <div class="modal fade share-bet-modal" id="qrPreviewModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered information-modal-wrapper">
            <div class="modal-content">
                <div class="modal-body">
                    <section class="sub-header-wrapper">
                        <div class="qrPreview-image">
                            <a href="javascript:void(0)">
                                <img :src="qrCode" class="offer-img" alt="qrcodeimage">
                            </a>
                        </div>
                    </section>
                </div>
                <div class="modal-footer qr-close-footer">
                    <button type="button" data-bs-dismiss="modal" aria-label="Close">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'qrCodeModal',
    props: ['qrCode']
}
</script>